import styled from 'styled-components';

export default styled.div`
  width: 100%;
  display: grid;
  grid-template-rows: auto 1fr;
  grid-template-areas:
    'header'
    'content';
`;
